<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.doorguestapply_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button
          v-show="scope.row.status != 4"
          type="text"
          size="small"
          icon="el-icon-s-custom"
          @click="openAuditDialog(scope.row)"
          >审核
        </el-button>
      </template>
      <template slot="auditStatus" slot-scope="scope">
        <el-tag
          type="danger"
          style="font-size: 8px;"
          size="medium"
          v-show="scope.row.auditStatus == 2"
          >拒绝</el-tag
        >
        <el-tag
          type="success"
          style="font-size: 8px;"
          size="medium"
          v-show="scope.row.auditStatus == 1"
          >同意</el-tag
        >
      </template>
    </avue-crud>
    <el-dialog title="审核" append-to-body :visible.sync="auditFlag" @closed="closedDialog()">
      <avue-form
        v-model="auditForm"
        ref="auditFormRef"
        :option="auditFormOption"
        @submit="auditSubmit"
      >
      </avue-form>
    </el-dialog>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  applyAudit,
} from '@/api/v4ward/door/guestapply/doorguestapply';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      auditForm: {},
      query: {},
      auditFlag: false,
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        align: 'center',
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 3,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: true,
        selection: false,
        dialogClickModal: false,
        menuWidth: 150,
        columnBtn: false,
        column: [
          {
            label: '小区名称',
            prop: 'communityId',
            dataType: 'string',
            type: 'tree',
            hide: true,
            searchSpan: 5,
            search: true,
            display: false,
            dicUrl: '/api/base/property/tree1?objectTypeKey=1',
            props: {
              label: 'title',
              value: 'id',
            },
          },
          {
            label: '小区名称',
            prop: 'communityName',
          },
          {
            label: '房间名称',
            hide: true,
            prop: 'objectFullName',
          },
          {
            label: '访问对象',
            width: 80,
            prop: 'targetPersonName',
          },
          {
            label: '申请人',
            width: 80,
            search: true,
            searchSpan: 3,
            prop: 'personName',
          },
          {
            label: '手机号',
            search: true,
            width: 100,
            searchSpan: 4,
            prop: 'mobile',
          },
          {
            label: '开始时间',
            prop: 'visitStartTime',
          },
          {
            label: '结束时间',
            prop: 'visitEndTime',
          },
          {
            label: '申请时间',
            hide: true,
            prop: 'applyTime',
          },
          {
            label: '申请原因',
            hide: true,
            prop: 'applyRemark',
          },
          {
            label: '审核人',
            hide: true,
            prop: 'auditBy',
          },
          {
            label: '审核状态',
            width: 80,
            searchSpan: 3,
            prop: 'auditStatus',
            slot: true,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=audit_status',
            props: { label: 'dictValue', value: 'dictKey' },
            dataType: 'number',
            search: true,
            rules: [
              {
                required: true,
                message: '请选择审核状态',
                trigger: 'change',
              },
            ],
          },
          {
            label: '审核流程',
            prop: 'status',
            width: 80,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=door_status',
            props: { label: 'dictValue', value: 'dictKey' },
            dataType: 'number',
          },
          {
            label: '审核时间',
            prop: 'auditTimeRange',
            search: true,
            hide: true,
            display: false,
            searchSpan: 6,
            searchRange: true,
            type: 'datetimerange',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
          },
          {
            label: '审核时间',
            prop: 'auditTime',
          },
          {
            label: '审核备注',
            hide: true,
            prop: 'auditRemark',
          },
        ],
      },
      auditFormOption: {
        align: 'center',
        addBtn: false,
        editBtn: false,
        delBtn: false,
        column: [
          {
            label: '审核状态',
            prop: 'auditStatus',
            type: 'select',
            dicData: [
              {
                label: '同意',
                value: 1,
              },
              {
                label: '拒绝',
                value: 2,
              },
            ],
            dataType: 'number',
            search: true,
            searchSpan: 6,
            rules: [
              {
                required: true,
                message: '请选择审核状态',
                trigger: 'change',
              },
            ],
          },
          {
            label: '审核备注',
            span: 24,
            prop: 'auditRemark',
            type: 'textarea',
            rules: [
              {
                required: false,
                message: '请填写不同意的备注信息',
                trigger: 'change',
              },
            ],
          },
        ],
      },
      data: [],
    };
  },
  watch: {
    'auditForm.auditStatus'() {
      const auditRemarkColumn = this.findObject(this.auditFormOption.column, 'auditRemark');
      if (this.auditForm.auditStatus != '' && this.auditForm.auditStatus == 2) {
        //根据审核状态动态控制审核备注是否必填
        auditRemarkColumn.rules[0].required = true;
      } else {
        auditRemarkColumn.rules[0].required = false;
      }
    },
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.doorguestapply_add, false),
        viewBtn: this.vaildData(this.permission.doorguestapply_view, true),
        delBtn: this.vaildData(this.permission.doorguestapply_delete, false),
        editBtn: this.vaildData(this.permission.doorguestapply_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    openAuditDialog(row) {
      this.auditForm.id = row.id;
      this.auditFlag = true;
    },
    auditSubmit(row, done, loading) {
      applyAudit(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
          this.auditFlag = false;
        },
        (error) => {
          window.console.log(error);
          done();
        }
      );
    },
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      if (this.query.auditTimeRange) {
        this.query.auditTimeStar = this.query.auditTimeRange[0];
        this.query.auditTimeEnd = this.query.auditTimeRange[1];
      }
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
    closedDialog() {
      this.$refs.auditFormRef.resetForm();
    },
  },
};
</script>

<style></style>
